import { EAccessLevel } from "../../../../shared/oversight-core/enums/access-level";
import { getAccessLevelInfo } from "../../../../shared/oversight-core/utils/get-org-user-info";
import styles from "./access-badge.module.scss";

interface IProps {
  level: EAccessLevel;
}

const AccessBadge = (props: IProps) => {
  const { label, color, bgColor } = getAccessLevelInfo(props.level);

  return (
    <span
      className={`${styles.accessBadge} font-size-11 font-weight-600`}
      style={{ color, backgroundColor: bgColor }}
    >
      {label}
    </span>
  );
};

export default AccessBadge;
